import { Link } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import classNames from 'classnames/bind'
import moment from 'moment'

import { observer } from 'mobx-react'

import { InjectHoverProvider } from 'modules/core/lib/hoverContext'
import i18n from 'modules/core/lib/i18n'

import { useRoute } from 'modules/time_planning/lib/RouteContext'
import type PlanningVersion from 'modules/time_planning/store/models/PlanningVersion'

import Menu from './Menu'
import styles from './index.module.css'

const cx = classNames.bind(styles)

export interface Props {
  employeeId: number
  canEditPlanningVersions: boolean
  planningVersion: PlanningVersion
  active: boolean
  onClickDelete: () => void
}
interface ContentProps {
  employeeId: number
  canEditPlanningVersions: boolean
  planningVersion: PlanningVersion
  onClickDelete: () => void
}

const Content = ({
  planningVersion,
  employeeId,
  canEditPlanningVersions,
  onClickDelete,
}: ContentProps) => {
  const title = i18n.t('time_planning.planning_versions.navigator.default')
  const date = moment(planningVersion.attributes.effective_at).format('ll')

  return (
    <>
      <Box className={styles.date}>{planningVersion.isDefault ? title : date}</Box>
      <Box className={styles.lines} />
      <Menu
        planningVersion={planningVersion}
        employeeId={employeeId}
        canEditPlanningVersions={canEditPlanningVersions}
        onClickDelete={onClickDelete}
      />
    </>
  )
}

const Item = ({
  employeeId,
  canEditPlanningVersions,
  planningVersion,
  active = false,
  onClickDelete,
}: Props) => {
  const future = planningVersion.future
  const route = useRoute()

  return (
    <InjectHoverProvider>
      <Link
        to={route.planningVersions(planningVersion.id)}
        className={cx('planning-version', {
          active,
          future,
        })}
        data-intercom-target={`planning-version-${active ? 'active' : 'inactive'}`}
      >
        <Content
          planningVersion={planningVersion}
          employeeId={employeeId}
          canEditPlanningVersions={canEditPlanningVersions}
          onClickDelete={onClickDelete}
        />
      </Link>
    </InjectHoverProvider>
  )
}

export default observer(Item)
